module.exports = ".view-button {\n  background: #4a90e2;\n  color: #ffffff;\n  border-radius: 5px; }\n"